__turbopack_context__.v({
  "active": "categoryListStyles-module-scss-module__pWfi5a__active",
  "categoryHeading": "categoryListStyles-module-scss-module__pWfi5a__categoryHeading",
  "inactive": "categoryListStyles-module-scss-module__pWfi5a__inactive",
  "majorRoutes": "categoryListStyles-module-scss-module__pWfi5a__majorRoutes",
  "mostSearchedCategoryList": "categoryListStyles-module-scss-module__pWfi5a__mostSearchedCategoryList",
  "show_more": "categoryListStyles-module-scss-module__pWfi5a__show_more",
});
